import logo from './logo.svg';
import './App.css';
import BattleScene from './scene/battle.js';

function App() {
  return (
    <div className="App">
        <BattleScene/>
    </div>
  );
}

export default App;
